import React, { useEffect } from 'react'

import styled from 'styled-components'

import { Spinner } from '../../components/Spinner'
import { useAuthContext } from '../../contexts'

const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
`

const Logout: React.SFC = () => {
  const { signOut } = useAuthContext()

  useEffect(() => {
    signOut()
  }, [])

  return (
    <>
      <Container>
        <Spinner />
      </Container>
    </>
  )
}

export { Logout }
